<template>
  <div
    data-qa="lpu_rating_category_card"
    class="lpu-rating-category-card bg-gray-0 rounded-20 pa-4 overflow-hidden"
  >
    <div class="d-flex flex-column ga-2 relative">
      <div
        class="text--text font-weight-medium"
        :class="hasScore ? 'lpu-rating-category-card__score--value' : 'text-body-1 text-info--text'"
      >
        {{ scoreText }}
      </div>
      <div class="text-body-1 text-secondary--text">
        {{ title }}
      </div>
    </div>
    <MaskIcon
      class="lpu-rating-category-card__icon text-lpu-branding-color-primary"
      :src="iconSrc"
      :size="110"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import formatRatingScore from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuRating/functions/formatRatingScore'
import MaskIcon from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/MaskIcon.vue'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'

const props = defineProps<{
  title: string
  score: number | null
  hasScore: boolean
  iconSrc: string
}>()

const scoreText = computed(() => (
  props.hasScore && props.score !== null
    ? formatRatingScore(props.score)
    : tStatic('Нет оценок')
))
</script>

<style lang="scss" scoped>
.lpu-rating-category-card {
  position: relative;
  box-shadow:
    0 2px 24px 0 rgba(9, 42, 72, 0.08),
    0 0 2px 0 rgba(21, 40, 92, 0.06),
    0 1px 2px 0 rgba(5, 23, 40, 0.08);

  &__score--value {
    font-size: 32px;
    line-height: normal;
  }

  &__icon {
    position: absolute;
    right: 16px;
    top: 16px;
    pointer-events: none;
  }
}
</style>
